import type { TableData } from "../types/reports.types";
import Table from "Components/Table/Table";

interface DataTableProps {
  table?: TableData;
}

export default function DataTable({ table }: DataTableProps) {
  if (!table) return null;

  return (
    <Table
      tableClassName="reportTable"
      data={table.rows}
      columns={table.columns.map((col, i) => ({
        header: col,
        render: (row: string[]) => row[i],
      }))}
    />
  );
}
